import { render, staticRenderFns } from "./FileMessage.vue?vue&type=template&id=f8de948c&scoped=true"
import script from "./FileMessage.vue?vue&type=script&lang=js"
export * from "./FileMessage.vue?vue&type=script&lang=js"
import style0 from "./FileMessage.vue?vue&type=style&index=0&id=f8de948c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8de948c",
  null
  
)

export default component.exports